import { render } from "./IFrame.vue?vue&type=template&id=07d231f8&scoped=true"
import script from "./IFrame.vue?vue&type=script&lang=js"
export * from "./IFrame.vue?vue&type=script&lang=js"

import "./IFrame.vue?vue&type=style&index=0&id=07d231f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d231f8"]])

export default __exports__